import React from 'react'

const FinalProduct = () => {
  return (
    <div>
      FinalProduct
    </div>
  )
}

export default FinalProduct
